export default {
  id: 'molten.timestamp.Between.ComparatorFilterConverter',
  type: 'timestamp.Between',
  convert: (cmp, attribute) => {
    const comparator1 = cmp.includesValue1 ? '[' : '(';
    const comparator2 = cmp.includesValue2 ? ']' : ')';
    const comparator = `${comparator1}${comparator2}`;
    if (cmp?.value1 == null || cmp.value2 == null) {
      return null;
    }
    return {
      type: 'comparison',
      value1: cmp.value1,
      value2: cmp.value2,
      comparator,
      field: attribute.blueprint.field,
      isDate: attribute.valueType === 'timestamp'
    };
  }
};